export default {
  IDLE: 'IDLE',
  DONE: 'DONE',
  ERROR: 'ERROR',
  RUNNING: 'RUNNING',
}
